import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../../Base/helper/baseFunctions";
import NProgress from 'nprogress';


export const GetECMSExitReasonHelper = async (params) => {
    NProgress.start()
    return await axiosInstance(`/ecms/getExitReason`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: params?.domain_name || getDomain(),
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "Exit reasons retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve exit reasons", hasError: true, data: err?.response?.data }
    });
};

export const AddECMSExitReasonHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/ecms/addExitReason`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            exit_reason: params?.exit_reason,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Exit reason added successfully");
        return { message: "Exit reason added successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to add exit reason", hasError: true, data: err?.response?.data }
    });
};

export const UpdateECMSExitReasonHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/ecms/updateExitReason`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            exit_reason: params?.exit_reason,
            exit_reasons_configuration_pk: params?.exit_reasons_configuration_pk,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Exit reason updated successfully");
        return { message: "Exit reason updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update exit reason", hasError: true, data: err?.response?.data }
    });
};

export const DeleteECMSExitReasonHelper = async (params) => {
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/ecms/deleteExitReason`, {
        method: "DELETE",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            exit_reasons_configuration_pk: params?.exit_reasons_configuration_pk,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Exit reason deleted successfully");
        return { message: "Exit reason deleted successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to delete exit reason", hasError: true, data: err?.response?.data }
    });
};
